module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"select-field-dialog\" title=\"Synchronize\" style=\"display: none;\">\r\n   <h4>The synchronization successfully completed.</h4>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label style=\"word-wrap: break-word\">")
    ; __append( resultsText)
    ; __append("</label>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}